import config from '@config';
import Tracker, { TrackerExtraUserData } from '@xFrame4/tracking/Tracker';

export enum AppTrackerEvent
{
    EmailClick = 'email_click',
    PhoneClick = 'phone_click',
    AddressClick = 'address_click',
    ContactFormSubmit = 'contact_form_submit',
    SpecialOfferContactFormSubmit = 'special_offer_contact_form_submit',
    BookNowEmailClick = 'book_now_email_click',
    BookNowPhoneClick = 'book_now_phone_click',
}

export class AppTracker extends Tracker
{
    protected static createInstance(): AppTracker 
    {
        return new AppTracker();    
    }

    // override
    protected async init()
    {
        this.lazyLoadScripts = true;
        this.trackWithGoogle = true;
        this.trackWithFacebook = true;
        this.trackWithFacebookConversionsApi = true;
        this.trackWithTikTok = true;
        this.trackWithTikTokEventApi = true;

        super.init();
    }

    /**
     * Track the mailto: click event
     */
    static trackEmailClick()
    {
        AppTracker.instance.logEvent(AppTrackerEvent.EmailClick);
    }

    /**
     * Track the tel: click event
     */
    static trackPhoneClick()
    {
        AppTracker.instance.logEvent(AppTrackerEvent.PhoneClick);
    }

    /**
     * Track the address click event (user clicks on the address link)
     */
    static trackAddressClick()
    {
        AppTracker.instance.logEvent(AppTrackerEvent.AddressClick);
    }

    /**
     * Track the contact form submit event
     * @param email - The email of the user
     * @param phone - The phone number of the user
     */
    static trackContactFormSubmit(email: string, phone?: string)
    {
        let extraUserData: TrackerExtraUserData = {
            emails: [email]
        };
        
        if (phone) {
            extraUserData.phoneNumbers = [phone];
        }

        // Log the general event
        AppTracker.instance.logEvent(AppTrackerEvent.ContactFormSubmit, undefined, extraUserData);

        // Log Google Ads conversion event
        // Conversion Label: Y6dHCJyJ6doaEJH9m74C
        AppTracker.instance.logGoogleAdsEvent("Y6dHCJyJ6doaEJH9m74C", {}, extraUserData);
    }

    /**
     * Track the special offer contact form submit event
     * @param email - The email of the user
     * @param phone - The phone number of the user
     */
    static trackSpecialOfferContactFormSubmit(email: string, phone?: string)
    {       
        let extraUserData: TrackerExtraUserData = {
            emails: [email]
        };
        
        if (phone) {
            extraUserData.phoneNumbers = [phone];
        }

        // Log the general event
        AppTracker.instance.logEvent(AppTrackerEvent.SpecialOfferContactFormSubmit, undefined, extraUserData);

        // Log Google Ads conversion event
        // Conversion Label: z9P9CJ-J6doaEJH9m74C
        AppTracker.instance.logGoogleAdsEvent("z9P9CJ-J6doaEJH9m74C", {}, extraUserData);
    }
}

export default AppTracker;